// frontend/src/components/SessionExpiredNotification.tsx
import React, { useEffect, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import styles from './SessionExpiredNotification.module.css';

interface SessionExpiredNotificationProps {
  show: boolean;
  onClose: () => void;
}

const SessionExpiredNotification: React.FC<SessionExpiredNotificationProps> = ({ show, onClose }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (show) {
      // Pequeno delay para animação de entrada
      setTimeout(() => setIsVisible(true), 100);
    } else {
      setIsVisible(false);
    }
  }, [show]);

  if (!show) return null;

  return (
    <div className={`${styles.overlay} ${isVisible ? styles.visible : ''}`}>
      <div className={`${styles.notification} ${isVisible ? styles.slideIn : ''}`}>
        <div className={styles.iconContainer}>
          <AccessTimeIcon className={styles.icon} sx={{ fontSize: 24 }} />
        </div>

        <div className={styles.content}>
          <h3 className={styles.title}>Sessão Expirada</h3>
          <p className={styles.message}>
            Você foi desconectado por inatividade. Por favor, faça login novamente.
          </p>
        </div>

        <button
          className={styles.closeButton}
          onClick={onClose}
          aria-label="Fechar notificação"
        >
          <CloseIcon sx={{ fontSize: 20 }} />
        </button>
      </div>
    </div>
  );
};

export default SessionExpiredNotification;
